<template>
  <div>
    <div class="store-info" v-if="system_store">
      <div class="info acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1" style="font-weight: bold;margin-bottom: 0.1rem;">
            {{ system_store.name }}
          </div>
          <div class="address acea-row row-middle" @click="showMap">
            <span class="addressTxt line1 address_tit">{{
              system_store.address
            }}</span
            ><span class="iconfont icon-youjian"></span>
          </div>
        </div>
        <div class="addressBox">
          <a
            class="iconfont icon-dadianhua01 font-color-red phone"
            :href="'tel:' + system_store.phone"
          ></a>
          <div class="addressTxt corlor-yshop" @click="showMap">
            距离{{ system_store.distance || 0.1 }}千米
          </div>
        </div>
      </div>
      <div class="info acea-row row-between-wrapper">
        <div class="text">
          <div style="font-size: 0.23rem;margin-bottom: 0.08rem;">
            门店简介：{{ system_store.introduction }}
          </div>
          <div style="font-size: 0.23rem;margin-bottom: 0.08rem;">
            营业时间：{{ system_store.dayTime }}
          </div>
          <div style="font-size: 0.23rem;margin-bottom: 0.08rem;">
            人均消费：￥{{ system_store.per }}
          </div>
        </div>
      </div>
      <div class="pictrue" style="padding: 0 0.32rem;">
        <img style="width: 100%; border-radius: 0.12rem;"
             :src="system_store.image" />
      </div>
    </div>
    <div class="store-info" v-if="goodsList">
      <div
        class="acea-row row-between-wrapper store-box"
        @click="toGoodsList"
        style="margin-top: 0.15rem"
      >
        <div class="title">精选商品</div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <GoodList :good-list="goodsList" :is-sort="true"></GoodList>
    </div>
    <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        "
      >
      </iframe>
    </div>
  </div>
</template>
<script>
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import { isWeixin } from "@utils";
import { wechatEvevt } from "@libs/wechat";
import { getGroomList, storeDetails } from "@api/store";
import cookie from "@utils/store/cookie";

const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";

export default {
  name: "StoreDetails",
  components: {
    GoodList
  },
  props: {},
  data: function() {
    return {
      mapKey: "",
      mapShow: false,
      system_store: {},
      goodsList: []
    };
  },
  mounted: function() {
    this.mapKey = cookie.get(MAPKEY);
    this.getStoreDetails();
    this.getIndexGroomList();
  },
  methods: {
    toGoodsList() {
      this.$router.push({
        path: "/goods_list",
        query: { deptIdValue: this.$route.params.id }
      });
    },
    showMap: function() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store.address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用查看地图，请配置您的腾讯地图key"
          );
        this.mapShow = true;
      }
    },
    getStoreDetails: function() {
      const that = this;
      let data = {
        latitude: cookie.get(LATITUDE) || "",
        longitude: cookie.get(LONGITUDE) || ""
      };
      let id = this.$route.params.id;
      storeDetails(id, data)
        .then(res => {
          console.warn(res.data)
          that.system_store = res.data;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },
    getIndexGroomList: function() {
      let that = this;
      let deptId = this.$route.params.id;
      getGroomList(99, deptId)
        .then(res => {
          that.goodsList = res.data.list;
        })
        .catch(function(res) {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    }
  }
};
</script>
<style scoped>
.store-box {
  padding: 0 0.3rem;
  border-bottom: 1px solid #f5f5f5;
}
.store-info {
  margin-top: 0.2rem;
  background-color: #fff;
}
.store-info .title {
  padding: 0 0.3rem;
  font-size: 0.28rem;
  color: #282828;
  height: 0.8rem;
  line-height: 0.8rem;
  border-bottom: 0.01rem solid #f5f5f5;
}
.store-info .info {
  padding: 0 0.3rem;
  height: 1.26rem;
}
.store-info .icon-jiantou {
  color: #7a7a7a;
  font-size: 0.28rem;
}
.store-info .info .pictrue {
  width: 0.76rem;
  height: 0.76rem;
}
.store-info .info .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.store-info .info .text {
  width: 56%;
}
.store-info .info .text .name {
  font-size: 0.3rem;
  color: #282828;
}
.store-info .info .text .address {
  font-size: 0.24rem;
  color: #666;
  margin-top: 0.03rem;
}
.store-info .info .text .address .iconfont {
  color: #707070;
  font-size: 0.18rem;
  margin-left: 0.1rem;
}
.address_tit {
  max-width: 88% !important;
}
.addressTxt {
  width: auto;
  font-size: 0.24rem;
}
.store-info .info .iconfont {
  font-size: 0.4rem;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
</style>
